/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, {Component} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import LoginView from './LoginView/LoginView';
import Layout from './Layout/Layout';
import {DomainApplicationViewContainer} from './DomainApplicationView/';
import {LanguageSelector} from './LanguageSelector';
import {authenticatedOrElse, userIsAuthenticated} from './auth';
import ErrorView from './ErrorView';
import {AutoLogout} from './AutoLogout';

/**
 * Define a SessionTimer component IF the user is authenticated.  Note that this is declared outside of the
 * render method to avoid a new instance everytime the render method is invoked.
 */
const SessionTimer = userIsAuthenticated(() => <AutoLogout debug={false} />);

const RedirectToLoginPage = () => <Redirect to='/' />;
const DomainApplicationViewPage = authenticatedOrElse(DomainApplicationViewContainer, RedirectToLoginPage);
const LanguagesPage = authenticatedOrElse(LanguageSelector, RedirectToLoginPage);

class App extends Component {
  
  render () {
    const redirectToApps = () => <Redirect to="/apps"/>;
    return (
      <Layout>
        <Switch>
          <Route exact path="/" component={authenticatedOrElse(redirectToApps, LoginView)} />
          <Route path="/apps" component={DomainApplicationViewPage}/>
          <Route path="/languages" component={LanguagesPage}/>
          <Route component={ErrorView} />
        </Switch>
        <SessionTimer/>
      </Layout>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js